export const DATA_KEYS = {
  field1: "props.title",
  pieChartType: "props.pieChartType",
  combineSegments: "props.combineSegments",
  numberOfSegments: "props.numberOfSegments",
  dimension1: "props.dimension1",
  dimension2: "props.dimension2",
  dimension3: "props.dimension3",
  dimension4: "props.dimension4",
  dimension1CustomRanges: "props.dimension1CustomRanges",
  dimension2CustomRanges: "props.dimension2CustomRanges",
  dimension3CustomRanges: "props.dimension3CustomRanges",
  dimension4CustomRanges: "props.dimension4CustomRanges",
  // Number field representation
  dimension1NumberFieldRepresentation: "props.dimension1NumberFieldRepresentation",
  dimension2NumberFieldRepresentation: "props.dimension2NumberFieldRepresentation",
  dimension3NumberFieldRepresentation: "props.dimension3NumberFieldRepresentation",
  dimension4NumberFieldRepresentation: "props.dimension4NumberFieldRepresentation",
  dimension1HistogramBucketMode: "props.dimension1HistogramBucketMode",
  dimension2HistogramBucketMode: "props.dimension2HistogramBucketMode",
  dimension3HistogramBucketMode: "props.dimension3HistogramBucketMode",
  dimension4HistogramBucketMode: "props.dimension4HistogramBucketMode",
  dimension1NumberOfBuckets: "props.dimension1NumberOfBuckets",
  dimension2NumberOfBuckets: "props.dimension2NumberOfBuckets",
  dimension3NumberOfBuckets: "props.dimension3NumberOfBuckets",
  dimension4NumberOfBuckets: "props.dimension4NumberOfBuckets",
  dimension1BucketSize: "props.dimension1BucketSize",
  dimension2BucketSize: "props.dimension2BucketSize",
  dimension3BucketSize: "props.dimension3BucketSize",
  dimension4BucketSize: "props.dimension4BucketSize",
  // Visibility (show/hide)
  hiddenDim1Datapoints: "props.hiddenDim1Datapoints",
  hiddenDim2Datapoints: "props.hiddenDim2Datapoints",
  hiddenDim3Datapoints: "props.hiddenDim3Datapoints",
  hiddenDim4Datapoints: "props.hiddenDim4Datapoints",
  dim1VisibilityPreset: "props.dim1VisibilityPreset",
  dim2VisibilityPreset: "props.dim2VisibilityPreset",
  dim3VisibilityPreset: "props.dim3VisibilityPreset",
  dim4VisibilityPreset: "props.dim4VisibilityPreset",
  dim1VisibilityN: "props.dim1VisibilityN",
  dim2VisibilityN: "props.dim2VisibilityN",
  dim3VisibilityN: "props.dim3VisibilityN",
  dim4VisibilityN: "props.dim4VisibilityN",
  hideZeroValues: "props.hideZeroValues",
};
